import { SPLIT_API_KEY } from '@bo-utils/environmentVariables';
import { SplitFactoryProvider } from '@splitsoftware/splitio-react';

export const splitConfig: SplitIO.IBrowserSettings = {
  core: {
    authorizationKey: SPLIT_API_KEY || window.backoffice.splitApiKey,
    key: 'anon'
  },
  debug: false,
  storage: {
    type: 'LOCALSTORAGE',
    prefix: 'PP_'
  }
};

interface SplitFactoryProps {
  children: React.ReactNode;
}

export const SplitFactory = ({ children }: SplitFactoryProps) => (
  <SplitFactoryProvider config={splitConfig}>{children}</SplitFactoryProvider>
);
